import { FeeType, SaleGetAllQuery } from '../../types';

export const getNotFounds = (
  data: SaleGetAllQuery,
  containerList: string[] | string,
): SaleGetAllQuery => {
  if (typeof containerList === 'string' || !containerList) return data;

  containerList = containerList.filter(
    (number) => !data.data.some((container: any) => container.number === number),
  );

  const result = [
    ...data.data,
    ...containerList.map((number) => ({
      number,
      id: '',
      isMyContainer: false,
      sale: {
        status: 'NOT_FOUND',
        ownerSetPrice: 0,
        feeValue: 0,
        feeType: FeeType.PERCENTAGE,
        finalPrice: 0,
      },
      images: [],
    })),
  ] as SaleGetAllQuery['data'];

  return {
    data: result,
    totalCount: result.length,
  };
};
